module.exports = __webpack_public_path__ + "static/bm-icon-red-black-eca956da56a922fdb3129a1cdb658b6a.png";